import { Select, Typography, Table } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../nestserver";
import LiveBusMap from "../../../admin/pages/Live tracking/LiveBusMap";

const { Option } = Select;
const { Title } = Typography;

const ParentLiveTracking = () => {
  const [routeId, setRouteId] = useState();
  const [routeData, setRouteData] = useState(null);
  const [studentRouteId, setStudentRouteId] = useState();

  // Fetch routes
  async function fetchRoute() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const routes = useQuery(["routes/v2"], () => fetchRoute());

  async function fetchStudent() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const students = useQuery("students/by-parent", fetchStudent);

  const handleStudentChange = (val) => {
    setRouteId(null);
    setStudentRouteId(val);
  };

  useEffect(() => {
    if (routes?.isSuccess && studentRouteId) {
      const filteredRoutes = routes?.data?.result?.data?.filter(
        (data) => data?._id === studentRouteId,
      );
      if (filteredRoutes?.length === 1) {
        setRouteId(filteredRoutes[0]._id);
      }
    }
  }, [routes, studentRouteId]);

  useEffect(() => {
    if (routeId) {
      const selectedRoute = routes?.data?.result?.data?.find(
        (data) => data?._id === routeId,
      );
      setRouteData(selectedRoute);
    }
  }, [routeId, routes]);

  async function fetchIssues(id) {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2/${id}/alerts`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }

  const issueDetails = useQuery(
    ["routes/v2/alerts", routeId],
    () => routeId && fetchIssues(routeId),
    {
      enabled: !!routeId,
    },
  );
  const columnsLog = [
    {
      title: "Date",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center"
        >
          {record?.createdAt
            ? moment(record?.createdAt).format("DD/MM/YYYY")
            : "-"}
        </div>
      ),
    },
    {
      title: "Alert",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => {
        return (
          <div
            key={record}
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {record?.alert}
          </div>
        );
      },
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full "
      >
        <div className="text-2xl text-orange-500 font-semibold mb-6">
          Live Tracking
        </div>
        <div className="flex" style={{ gap: "48px" }}>
          <div className="flex flex-col w-310">
            <h3 className="text-base pb-3"> Students*</h3>
            <Select
              showSearch
              showArrow
              placeholder="Select student"
              className="w-full bg-gray-300"
              style={{
                border: "6px",
                backgroundColor: "#EBEBEB",
                width: "300px",
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(value) => handleStudentChange(value)}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {students?.isSuccess &&
                students?.data?.result?.map((data) => {
                  return (
                    <Option
                      key={data.user?.route_id}
                      value={data.user?.route_id}
                    >
                      {`${data?.first_name} ${data?.last_name}`}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="flex flex-col w-310">
            <h3 className="text-base pb-3"> Route</h3>
            <Select
              showSearch
              showArrow
              placeholder="Select route"
              className="w-full bg-gray-300 capitalize"
              style={{
                border: "6px",
                backgroundColor: "#EBEBEB",
                width: "300px",
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(value) => setRouteId(value)}
              value={routeId || undefined}
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              disabled
            >
              {routes?.isSuccess &&
                routes?.data?.result?.data
                  ?.filter((data) => data?._id === studentRouteId)
                  ?.map((data) => {
                    return (
                      <Option key={data._id} value={data._id}>
                        {data?.name}
                      </Option>
                    );
                  })}
            </Select>
          </div>
        </div>

        <div className="pt-4">
          <LiveBusMap
            routeData={routeData}
            routeId={routeId}
            routes={routes?.data?.result?.data || []}
          />
        </div>

        <Title level={5} className="pt-8">
          Alert Log
        </Title>
        <div className="py-5">
          <Table
            rowKey="_id"
            columns={columnsLog}
            dataSource={
              issueDetails?.isSuccess &&
              issueDetails?.data?.result?.data?.length > 0 &&
              issueDetails?.data?.result?.data
                ? issueDetails?.data?.result?.data
                : []
            }
            pagination={true}
            loading={issueDetails?.isLoading}
            locale={{ emptyText: "No alerts for this route" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ParentLiveTracking;
